import t from "./ghl-ui.es1157.js";
const e = (o) => {
  const {
    cubicBezierEaseInOut: n
  } = o;
  return {
    bezier: n
  };
}, i = {
  name: "CollapseTransition",
  common: t,
  self: e
}, a = i;
export {
  a as default,
  e as self
};
